import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PatientCall } from '../patient-call.service';

@Component({
  selector: 'app-patient-call-stop-button',
  templateUrl: './patient-call-stop-button.component.html',
  styleUrls: ['./patient-call-stop-button.component.scss'],
  standalone: false
})
export class PatientCallStopButtonComponent implements OnInit {
  @Input() patientCall: PatientCall;
  @Input() disabled: boolean = false;
  @Output() patientCallEndEventEmitter = new EventEmitter<PatientCall>();
  constructor() {}

  ngOnInit() {}
  stopPatientCall() {
    if (this.disabled) {
      return;
    }

    this.patientCallEndEventEmitter.emit(this.patientCall);
  }
}
